import { ReactNode, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../@types/RootState';
import { selectorDataPointsExhibitionType, SET_DATA_POINTS_EXHIBITION_TYPE } from '../../../reducers/gerenciadorPrecos/datapointExhibitionType';
import { getCurrentPriceManagerUserKey, selectPriceManagerView, usePriceManagerViewStore } from '../../../store/priceManagerViewStore';

interface PriceManagerViewBootstrapProps {
  children: ReactNode;
}

const ANONYMOUS_USER_KEY = '__anonymous__';

export const PriceManagerViewBootstrap = ({ children }: PriceManagerViewBootstrapProps) => {
  const dispatch = useDispatch();
  const reduxView = useSelector(selectorDataPointsExhibitionType);
  const pricingPreference = useSelector((state: RootState) => state.reducerIPA.basicConfig.competitorsDays.pricing_preferences);
  const userKey = getCurrentPriceManagerUserKey();
  const initializationKey = userKey ?? ANONYMOUS_USER_KEY;
  const preferredView = usePriceManagerViewStore(state => selectPriceManagerView(state, userKey));
  const isClusterView = preferredView === 'PRODUCT_CLUSTER' || preferredView === 'PRODUCT_CLUSTER_FAMILY';
  const effectivePreferredView =
    pricingPreference === 'STORE' && isClusterView ? (preferredView === 'PRODUCT_CLUSTER_FAMILY' ? 'FAMILY' : 'PRODUCT') : preferredView;
  const [initializedUserKey, setInitializedUserKey] = useState<string | null>(null);

  useLayoutEffect(() => {
    if (reduxView !== effectivePreferredView) {
      dispatch(SET_DATA_POINTS_EXHIBITION_TYPE(effectivePreferredView));
    }

    setInitializedUserKey(initializationKey);
  }, [dispatch, effectivePreferredView, initializationKey, reduxView]);

  if (initializedUserKey !== initializationKey) return null;

  return <>{children}</>;
};
